import { useEffect } from "react";
import { apiRequest } from "../lib/api";
import { useAsync } from "./useAsync";

export interface StaffMessagingPreferences { undoSendEnabled: boolean }

export function useStaffMessagingPreferences() {
  const result = useAsync((signal) => apiRequest<StaffMessagingPreferences>("/agent/profile/messaging", { signal }), []);
  useEffect(() => {
    const refresh = () => { void result.refresh(); };
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [result.refresh]);
  return result;
}
